import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import moment from 'moment';
import React, { useState } from 'react';
import { getFirestore, doc } from 'firebase/firestore';
import { useDocument, useDocumentData } from 'react-firebase-hooks/firestore';
import { app } from '../../../core/firebase';
import { IConfirmation } from '../schemas';
import { IOrganizationEnhanced } from '../utils';

export interface IBookingCard {
  data: IConfirmation;
}
export default function BookingCard(props: IBookingCard) {
  const { data } = props;
  const [organization] = useDocumentData<IOrganizationEnhanced>(
    doc(getFirestore(app), `scout9-organizations`, data.organizationId) as any,
  );
  // const [request] = useDocument(db.doc(`scout9-profiles/${data.uid}/dogs/${data.dogId}/requests/${data.organizationId}`));
  const [timestamp] = useState(moment(data.appointmentTime).format('MMM Do YYYY, h:mm a'));
  return (
    <Card>
      <CardContent>
        <List>
          <ListItem>
            <ListItemText primary={`Business: ${organization && organization.name}`}/>
          </ListItem>
          <ListItem>
            <ListItemText primary={`Time: ${timestamp}`}/>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={`Location: ${organization && organization.places && organization.places.formatted_address}`}/>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={`Phone: ${organization && organization.places && organization.places.formatted_phone_number}`}/>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
}
